var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen bg-gray-200 antialiased xl:flex xl:flex-col xl:h-screen"},[_c('the-header',{staticClass:"xl:flex-shrink-0"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }